import axios,  { AxiosResponse } from 'axios';
import { responseAPI } from './IResponseAPI'

const storeMethod: string = 'store';
const validFolioMethod: string = 'isValidFolio';
const loginSOA2: string = 'auth/login';
const crearAfiliado: string = 'v1/registro-afiliado-v2';
const urlApi: any = process.env.REACT_APP_ENVIROMENT === "production" ? process.env.REACT_APP_URL_AUTHENTICATE : process.env.REACT_APP_URL_AUTHENTICATE_ENV;
// const urlApi = 'https://bluediamondresorts.masservicios.com.mx/api/rest/gonherMotos/'
const ApiCarteraMAsS: any = process.env.REACT_APP_API_CARTERA;

const store = async(data: any) =>{
    const response = await axios.post(`${urlApi}${storeMethod}`,data).then((response:AxiosResponse<any>)=> {

        const resp: responseAPI = {
            success: response.status === 200 ? true : false,
            data: response.status === 200 ? response.data.data : response.data.errors[0],
            message: response.status === 200 ? "Ok" : 'Bad Request'
        }

        return resp;

    }).catch(error =>{

        const resp: responseAPI = {
            success: false,
            data: error.response.data.errors,
            message: 'Bad Request'
        }

        return resp;
    });

    return response
}

const validFolio = async(data: any) =>{
    const response = await axios.post(`${urlApi}${validFolioMethod}`,data).then((response:AxiosResponse<any>)=> {

        const resp: responseAPI = {
            success: response.status === 200 ? true : false,
            data: response.status === 200 ? response.data.data : response.data.errors,
            message: response.status === 200 ? "Ok" : "Bad Request"
        }

        return resp;

    }).catch(error => {

        const resp: responseAPI = {
            success: false,
            data: error.response.data.errors,
            message: 'Bad Request'
        }

        return resp;
    });

    return response
}


const loginApiCarteraMasS = async (data: any) => {
    const response = await axios.post(`${ApiCarteraMAsS}${loginSOA2}`, data)
        .then((response : AxiosResponse) => {

            const resp: responseAPI = {
                success: response.status === 200 ? true : false,
                data: response.status === 200 ? response.data.data : response.data.errors,
                message: response.status === 200 ? "Ok" : "Bad Request"
            }
            return resp
        })
        .catch( error => {
            console.log(error);
            const resp: responseAPI = {
                success: false,
                data: error.response.data.errors,
                message: 'Bad Request'
            }

            return resp
        } )
    
    return response
}

const crearAfiliadoApiCarteraMasS = async (data: any, token: string) => {
    const response = await axios.post(`${ApiCarteraMAsS}${crearAfiliado}`, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    })
        .then((response : AxiosResponse) => {

            const resp: responseAPI = {
                success: response.status === 200 ? true : false,
                data: response.status === 200 ? response.data.data : response.data.errors,
                message: response.status === 200 ? "Ok" : "Bad Request"
            }
            return resp
        })
        .catch( error => {
            console.log(error);
            const resp: responseAPI = {
                success: false,
                data: error.response.data.errors,
                message: 'Bad Request'
            }

            return resp
        } )
    
    return response
}


const functions = {
    store, validFolio, loginApiCarteraMasS, crearAfiliadoApiCarteraMasS
}


export default functions;